export default __webpack_public_path__ + "static/IN-8015HD_Quick-Installation_P2P-WPS_02-2ff1e90a0c84c6fd5ecd1f7d5cbe0bbc.webp";